export const params = () => {
    return {
        filter: null,
        page: 1,
        per_page: 10,
        paginate: 1,
        company_id: null,
        provider_id: null,
        manufacturer_id: null
    };
};

export const product = () => {
    return {
        id: null,
        activo: 1,
        verificado: 0,
        temporal: 1,
        nombre: '',
        sinonimos: '',
        componentesactivos: "",
        cas: '',
        estado: null,
        id_fabricante: null,
        uso: '',
        observacion: '',
        disposiciontratamiento: ''
    }
};

export const attachment = () => {
    return {
        idioma: '',
        tipo: '',
        estado_fds: '',
        sistema: 'no',
        observacion: '',
        avatar: null,
        fecha: '',
        cumple_decreto: '',
        activo: 1,
        no_cumple: 1,
        observacion_no_cumple: '',
        url: null
    }
}

export default {
    product: product(),
    params: params(),
    attachment: attachment(),
    editing: false,
    companies: [],
    providers: [],
    manufacturers: [],
    manufacturers_form: [],
    fds_states: [],
    types: [],
    languages: [],
    only_view: false,
    products: {
        data: []
    },
    modal: {
        show: false,
        step: 0
    },
    states: [
        { value: 131, text: "Solido" },
        { value: 132, text: "Liquido" },
        { value: 133, text: "Gaseoso" }
    ]
};
